import { Component } from '@angular/core';
import { ProjectService } from '../services/project.service';

@Component({
  selector: 'app-new',
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.scss'],
})
export class NewComponent {
  projectName: string = '';

  constructor(public projectService: ProjectService) {}

  onStart(): void {
    this.projectService.startProject(this.projectName).subscribe(
      (data) => {
        console.log('Start Project API Result: ' + data);
      },
      (error) => {
        console.log('Start Project API Error: ' + error);
      }
    );
  }
}
